export const SET_MINI = 'SET_MINI'
export const SET_IS_PENDO_LOADED = 'SET_IS_PENDO_LOADED'
export const SET_APP_STATE = 'SET_APP_STATE'
